import React, { useContext } from "react";
import { Switch, Tooltip } from "antd";
import SpectrumContext from "./SpectrumContext";
import "./SpectrumForm.scss";

export default function GuideToolbar() {
  const {
    enableGuide,
    setEnableGuide,
    enableSpace,
    setEnableSpace,
    enableDraw,
    setEnableDraw,
  } = useContext(SpectrumContext);

  return (
    <div className="SpectrumForm">
      <div className="inline-field">
        <label className="ant-form-item-label">대역폭 측정</label>
        <Tooltip
          title={"클릭한 위치의 주파수를 보여줍니다."}
          placement={"bottom"}
          className="tooltip"
        >
          <Switch
            checked={enableDraw}
            onChange={checked => setEnableDraw(checked)}
          />
        </Tooltip>
      </div>

      <div className="inline-field">
        <label className="ant-form-item-label">주파수 보기</label>
        <Tooltip
          title={"마우스 커서가 위치한 주파수를 보여줍니다."}
          placement={"bottom"}
          className="tooltip"
        >
          <Switch
            checked={enableGuide}
            onChange={checked => setEnableGuide(checked)}
          />
        </Tooltip>
      </div>

      <div className="inline-field">
        <label className="ant-form-item-label">대역폭 보기</label>
        <Tooltip
          title={"각 주파수 대역의 시작/끝 주파수를 보여줍니다."}
          placement={"bottom"}
          className="tooltip"
        >
          <Switch
            checked={enableSpace}
            onChange={checked => setEnableSpace(checked)}
          />
        </Tooltip>
      </div>

      <div
        className="inline-field"
        style={{ color: "#eb6100", fontSize: "11px" }}
      >
        ※ 시작 및 종료주파수, 단위를 먼저 설정 후 지역,구분,용도 선택후에 무선국
        통계검색을 클릭하세요!
      </div>
    </div>
  );
}
